import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAdd = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.75 0.75C8.75 0.541667 8.67708 0.364583 8.53125 0.21875C8.38542 0.0729167 8.20833 0 8 0C7.79167 0 7.61458 0.0729167 7.46875 0.21875C7.32292 0.364583 7.25 0.541667 7.25 0.75V7.25H0.75C0.541667 7.25 0.364583 7.32292 0.21875 7.46875C0.0729167 7.61458 0 7.79167 0 8C0 8.20833 0.0729167 8.38542 0.21875 8.53125C0.364583 8.67708 0.541667 8.75 0.75 8.75H7.25V15.25C7.25 15.4583 7.32292 15.6354 7.46875 15.7812C7.61458 15.9271 7.79167 16 8 16C8.20833 16 8.38542 15.9271 8.53125 15.7812C8.67708 15.6354 8.75 15.4583 8.75 15.25V8.75H15.25C15.4583 8.75 15.6354 8.67708 15.7812 8.53125C15.9271 8.38542 16 8.20833 16 8C16 7.79167 15.9271 7.61458 15.7812 7.46875C15.6354 7.32292 15.4583 7.25 15.25 7.25H8.75V0.75Z",
		fill: "#006ADC"
	})
});
const ForwardRef = forwardRef(SvgAdd);
export default ForwardRef;
